/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReactNode } from "react";
import { If, Then } from "react-if";
import { Button, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { LoaderWrap } from "~/components";
import { DetailWrapper, ValueWrapper } from "~/components/Details/styles";

type Props = {
  loading: boolean;
  nextExecutionDate: (() => string) | undefined;
  handleEdit: () => void;
  scheduleDetails?: ReactNode;
};
export function NextExecutionComponent({
  loading,
  nextExecutionDate,
  handleEdit,
  scheduleDetails,
}: Props) {
  const hasScheduleDetails = !!scheduleDetails;

  return (
    <>
      <DetailWrapper data-testid="Next execution">
        <FlexContainer alignItems="flex-start" direction="column">
          <Text
            tag="div"
            size="sm"
            color={theme.color.text.text02}
            css={{ textDecoration: "none" }}
          >
            Next execution (plan time)
          </Text>
          <ValueWrapper editable={!hasScheduleDetails} isEmpty={false}>
            <LoaderWrap loading={loading} inContent>
              <div data-testid="Plan Cron">
                <div>{nextExecutionDate?.() ?? "On Demand"}</div>
                <If condition={hasScheduleDetails}>
                  <Then>
                    <div>{scheduleDetails}</div>
                  </Then>
                </If>
              </div>
            </LoaderWrap>
          </ValueWrapper>
        </FlexContainer>
        <Button
          aria-label="edit button"
          icon="edit"
          size="md"
          severity="low"
          ml={theme.spacing.spacing02}
          onClick={handleEdit}
          css={{ visibility: "hidden" }}
        />
      </DetailWrapper>
    </>
  );
}

export default NextExecutionComponent;
